import esLocaleData from 'react-intl/locale-data/es'

import en from './en'
import es from './es'

export default {
  en: en,
  es: es
}

export const localeData = [
  ...esLocaleData
]
